<template>
  <div class="container">
    <div class="order-container" v-if="scanStatus.isAllowScan == 1">
      <div class="order-content menu-content" @click="goToDelivery">
        <img src="../../../assets/home-order.png" />
        <div class="name">
          立即点餐
        </div>
      </div>
    </div>
    <div class="logo-container">
      <img src="../../../assets/home-logo.png" />
    </div>
    <div class="like-container" @click="handleDownload">
      <div class="like-content menu-content">
        <img src="../../../assets/home-like.png" />
        <div class="name">
          关注商家
        </div>
      </div>
    </div>

    <div class="bottom-copyright">西米团智慧餐厅</div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import moment from "moment";
import Store from "../../../api/store";

export default {
  data: function() {
    return {
      storeGuid: "",
      startTime: moment().unix(),
      scanStatus: {}
    };
  },

  created() {
    if (this.$route.query.storeGuid) {
      this.setStoreId(this.$route.query.storeGuid);
      this.storeGuid = this.$route.query.storeGuid;

      this.getStoreInfo();
      this.loadScanStatus();
    }
  },

  computed: {
    ...mapState(["storeInfo"])
  },

  methods: {
    ...mapActions(["getStoreInfo"]),
    ...mapMutations(["setStoreId"]),

    goToDelivery() {
      this.$router.push(
        `/store?storeGuid=${this.storeGuid}&startTime=${this.startTime}`
      );
    },

    async loadScanStatus() {
      try {
        const {
          data: { isError, data }
        } = await Store.getScanStatus({});

        if (isError) {
          return;
        }

        this.scanStatus = data;
      } catch (e) {
        console.log(e);
      }
    },

    handleDownload() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端

      if (isAndroid) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.technology.geat";
      } else if (isIOS) {
        window.location.href =
          "https://apps.apple.com/es/app/geat/id1466834290";
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./home.sass"></style>
